import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';

import { AskTemplatesDataService } from '@core/ask-hr-templates-logic';
import type { AskPredefinedTemplate } from '@core/ask-hr-templates-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { RenderDirective } from '@core/prosemirror-legacy/angular';
import {
  ProsemirrorBasicConfig,
  ProsemirrorBasicConfigDirective,
} from '@core/prosemirror-legacy/webapp';
import { SymbolComponent } from '@core/symbol-legacy';
import { HeadingComponent, IconContainerComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'ask-hr-add-new-template',
  imports: [
    HeadingComponent,
    TranslatePipe,
    SymbolComponent,
    ProsemirrorBasicConfigDirective,
    RenderDirective,
    IconContainerComponent,
  ],
  templateUrl: './add-new-template.component.html',
  styleUrl: './add-new-template.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddNewTemplateComponent {
  private readonly templatesDataService = inject(AskTemplatesDataService);

  protected readonly ProsemirrorBasicConfig = ProsemirrorBasicConfig;

  public selectedTemplate = output<AskPredefinedTemplate | null>();

  protected predefinedTemplates = this.templatesDataService.predefinedTemplates;

  public ngOnInit(): void {
    this.templatesDataService.loadPredefinedTemplates();
  }

  protected openTemplateEdit(template: AskPredefinedTemplate | null) {
    this.selectedTemplate.emit(template);
  }
}
